import { Colors } from "../colors";
import { Theme } from "./theme";

export const themeLight: Theme = {
  primaryBackgroundColor: Colors.ALABASTER,
  primaryAccentColor: Colors.ECSTASY,
  primaryTextColor: Colors.BLACK,
  primaryFont: "'Open Sans', sans-serif",
  secondaryFont: "'Source Serif Pro', serif",
};
